// extracted by mini-css-extract-plugin
export default {"margin":"SnapTabs__margin-qCEjM"};